import React from "react";
import { Paper } from "@material-ui/core/";
import DisaggThankyouPage from "../DisaggComponents/DisaggThankyouPage";
import DisaggMain from "../DisaggComponents/DisaggMain";
import { connect } from "react-redux";
import { trackEvent  } from "../../../../helpers/analyticsHelper";
import { PAGE_EVENT_NAMES } from "../../../../constants/common";
import { withLastLocation } from "react-router-last-location";
import { getUserLocale } from "../../../../helpers/helper";
import FooterMain from "../../../standalone/common/Footer/FooterMain";


class DisaggMainContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      thumbsUp: false,
      thumbsDown: false,
      translationsData: this.props.translationsData ? this.props.translationsData : "",
      mixpanelProperties: {
        clicked: '',
        type: null
      },
      mpPropertiesSent: false,
      uuid: this.props.userObj.details.uuid
    };
    
  }

  thumbsUpClick = () => {
    this.setState({
        thumbsUp: true ,
        mixpanelProperties:{
          clicked: 'feedbackThumb',
          type: 'POSITIVE'
        }
      });
  };

  thumbsDownClick = () => {
    this.setState({ 
        thumbsDown: true,
        mixpanelProperties:{
          clicked: 'feedbackThumb',
          type: 'NEGATIVE'
      } 
    });
  };

  componentDidMount(){
    trackEvent(this.state.uuid , PAGE_EVENT_NAMES.FAQ , {
      viewed : true,
      locale: getUserLocale(this.props.configs.data),     
    },this.props);
  }


  componentDidUpdate(){
    if(!this.state.mpPropertiesSent && (this.state.thumbsDown || this.state.thumbsUp)){
      this.setState({mpPropertiesSent:true});
      trackEvent(this.state.uuid, PAGE_EVENT_NAMES.FAQ ,this.state.mixpanelProperties);
    }
  };

  render() {
    return (
    <>
      <Paper className="disagg101-main">
        {(this.state.thumbsUp || this.state.thumbsDown) === true ? (
          <DisaggThankyouPage userObj={this.props.userObj} configs={this.props.configs} translations={this.state.translationsData} />
        ) : (
          <DisaggMain onSubmitPositive={this.thumbsUpClick} onSubmitNegative={this.thumbsDownClick} translations={this.state.translationsData} configs={this.props.configs} userObj={this.props.userObj} />
        )}
      </Paper>
      {this.props.configs && this.props.configs.data && this.props.configs.data["DASHBOARD.FAQ_PAGE.FOOTER.SHOW"] === "true" ?
          (<FooterMain configs={this.props.configs} translations={this.props.translationsData} footerNote={this.props.translationsData.data["FOOTER.FAQ_PAGE.FOOTER_NOTE"]}/>)
          : ''
      }
    </>
    );
  }
}
const mapStateToProps = state => {
  return {
    userObj: state.userObject,
    configs: state.configs,
    translationsData: state.translationsData,
    queryParams: state.queryParams
  };
};

export default withLastLocation(connect(mapStateToProps)(DisaggMainContainer));
